import {NavigateBefore, NavigateNext,ArrowCircleLeft} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import {getParcel} from "../services/service";
import {Parcletable, Spinner} from "../components";
import {useNavigate} from 'react-router-dom'
import {IconButton} from '@mui/material'


const Parcelslist = () => {
    const navigate = useNavigate();





    const [data, setData] = useState(false)

    const [search, setSearch] = useState('')



    const getParcellist = async (page) => {
        const token = JSON.parse(localStorage.getItem('admin'))
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                take: 10, page: page, search: search,
            }
        }
        const response = await getParcel(config)

        if (response) {
            setData(response.data)

        }

    }
    useEffect(() => {



        getParcellist()



    }, []);


    useEffect(() => {

        setData(false)


        getParcellist()


    },[search])






    let content
    if (data !== false) {
        if (data.items.length > 0) {

            const width = 559;
            const height = 794;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);
            content =
                data.items.map((item) => {
                    return (
                        <>
                            <tr key={item.id} className='has-text-centered yekan'>

                                <td>{item.parcels.tracking_code}</td>
                                <td>{item.cities.name}</td>
                                <td>{item.parcels.sender_name}</td>
                                <td>{item.parcels.sender_name}</td>

                                <td>{item.parcels.receiver_name}</td>

                                <td>{item.parcels.address}</td>
                                <td>{item.parcels.type}</td>
                                <td>

                                    <IconButton
                                        onClick={() => window.open(`/parcel/${item.parcels.tracking_code}`, '_blank', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`)}>
                                        <ArrowCircleLeft/>
                                    </IconButton>


                                </td>

                                <td>

                                    <IconButton
                                        onClick={() => window.open(`/parcel/logs/${item.parcels.tracking_code}`, '_blank', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`)}>
                                        <ArrowCircleLeft/>
                                    </IconButton>


                                </td>


                            </tr>
                        </>

                    )
                })

        } else {
            content =
                <div className='column is-12'>
                    <p className='my-3'>
                        بسته ای برای نمایش وجود ندارد 🤷‍♀️

                    </p>
                </div>

        }


    } else {
        content = <div className='column is-12'>
            <Spinner/>
        </div>
    }


    return (
        <>
            <div className='column is-12 welcome__master p-5 my-4 '>

                <h2 className='has-text-centered pinar is-size-4 clrtwotext has-text-weight-bold'>
                    لیست کامل مرسوله ها
                </h2>


                <input onChange={(e)=>setTimeout(()=>setSearch(e.target.value),1000)} className='input is-success my-3' type="text" placeholder='جستجو بر اساس نام شماره تلفن یا شهر یا کد رهگیری و ...'/>


                <p>
                    {search}
                </p>

                <div className='column is-12 p-3'>
                    <div className='welcome__master p-3' style={{width: '100%', height: '100%'}}>


                        <table className='table width100'>
                            <thead className='clrtwo'>
                            <tr className=''>
                                <th className='has-text-centered has-text-white'>کد رهگیری</th>
                                <th className='has-text-centered has-text-white'>مبدا</th>
                                <th className='has-text-centered has-text-white'>مقصد</th>
                                <th className='has-text-centered has-text-white'>نام فرستنده</th>

                                <th className='has-text-centered has-text-white'>نام گیرنده</th>

                                <th className='has-text-centered has-text-white'>آدرس</th>
                                <th className='has-text-centered has-text-white'>وضعیت</th>
                                <th className='has-text-centered has-text-white'>فاکتور و جزئیات</th>

                                <th className='has-text-centered has-text-white'>رویداد های مرسوله</th>


                            </tr>

                            </thead>

                            <tbody>

                            {
                                content
                            }


                            </tbody>
                        </table>


                    </div>
                </div>


                <div className='column is-12'>
                    {data &&
                        <div className='pinar' style={{display: 'flex', justifyContent: 'center'}}>


                            {/*before page with tick*/}
                            {
                                data.paginator.beforePage < data.paginator.currentPage && (

                                    <button onClick={() => getParcellist(data.paginator.beforePage)} className='button'>
                                        <NavigateNext/>
                                    </button>
                                )


                            }


                            {/*map beforePages*/}
                            {data.paginator.beforePages.length > 0 &&

                                <>
                                    {data.paginator.beforePages.map((item, index) =>
                                        <button className='button' onClick={() => getParcellist(item)} key={index}>
                                            {item}
                                        </button>
                                    )}
                                </>

                            }


                            {/*active*/}

                            {
                                data.paginator.total > 0 &&
                                <button
                                    className='clrtwo has-text-white button'>{data.paginator.currentPage}</button>


                            }


                            {/*map nextPages*/}
                            {data.paginator.nextPages.length > 0 &&
                                <>
                                    {data.paginator.nextPages.map((item, index) =>
                                        <button className='button' onClick={() => getParcellist(item)} key={index}>
                                            {item}
                                        </button>
                                    )}
                                </>

                            }


                            {/*next page with tick*/}
                            {

                                data.paginator.nextPage > data.paginator.currentPage && (

                                    <button onClick={() => getParcellist(data.paginator.nextPage)}
                                            className='button is-transparent'>
                                        <NavigateBefore/>
                                    </button>
                                )


                            }


                        </div>
                    }
                </div>


            </div>

        </>
    )
}
export default Parcelslist